import styled from 'styled-components'

interface SliderContainerProps {
  className?: string
  disabled?: boolean
}

interface SliderTrackProps {
  trackColor?: string
  disabled?: boolean
}

interface SliderRangeProps {
  progress: number
  rangeColor?: string
  disabled?: boolean
}

interface SliderThumbProps {
  progress: number
  thumbBorderColor?: string
  disabled?: boolean
}

export const SliderContainer = styled.div<SliderContainerProps>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  touch-action: none;
  user-select: none;
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
`

export const SliderTrack = styled.div<SliderTrackProps>`
  position: relative;
  height: 8px;
  width: 100%;
  overflow: hidden;
  border-radius: 9999px;
  background-color: ${(props) => props.trackColor || '#e2e8f0'};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`

export const SliderRange = styled.div<SliderRangeProps>`
  position: absolute;
  height: 100%;
  background-color: ${(props) => props.rangeColor || '#4D4BE7'};
  width: ${(props) => props.progress}%;
  opacity: ${(props) => (props.disabled ? '0.7' : '1')};
`

export const SliderThumb = styled.div<SliderThumbProps>`
  display: block;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  border: 2px solid ${(props) => props.thumbBorderColor || '#4D4BE7'};
  background-color: #ffffff;
  position: absolute;
  top: 50%;
  left: ${(props) => (props.progress <= 0.5 ? '0%' : `${props.progress}%`)};
  transform: ${(props) => (props.progress <= 0.5 ? 'translate(0%, -50%)' : 'translate(-50%, -50%)')};
  transition: border-color 0.3s;

  &:focus {
    outline: none;
    box-shadow: ${(props) => (props.disabled ? 'none' : '0 0 0 2px rgba(0, 0, 0, 0.1)')};
  }

  &:hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }

  &:active {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'grabbing')};
  }
`
